/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DataVaxiomEmployerForm/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Address from './Address/index'
import CancelAction from './CancelAction/index'
import Email from './Email/index'
import Name from './Name/index'
import Phone from './Phone/index'
import React from 'react'
import SaveAction from './SaveAction/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function DataVaxiomEmployerForm({
  children,
  viewPath = "/DesignSystem/DataVaxiomEmployerForm"
  
}) {
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
  return (<React.Fragment
>
<Name
  viewPath={`${viewPath}/Name`}
/>
<Address
  viewPath={`${viewPath}/Address`}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={dtSpaceM}
 text="Contact Information"
/>
<Phone
  viewPath={`${viewPath}/Phone`}
/>
<Email
  viewPath={`${viewPath}/Email`}
/>
<div
  data-testid="DataVaxiomEmployerForm.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-Z1teaRy': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Horizontal}`}
>
<CancelAction
  viewPath={`${viewPath}/CancelAction`}
/>
<SaveAction
  viewPath={`${viewPath}/SaveAction`}
/>
</div>
{children}
</React.Fragment>)
}